module.exports = __webpack_public_path__ + "968b7734117ebad64281aa3154223f42.png";